import { PollingIntervalGroups } from "apollo/constants";
import useOpenTofuMigrationCounts from "shared/Stack/OpenTofuMigration/useCounts";

const useOpenTofuMigration = () => {
  const { eligibleToMigrate, queuedToMigrate, isLoading, error, refetch } =
    useOpenTofuMigrationCounts(PollingIntervalGroups.Dashboard);

  const isEmpty = !isLoading && !error && eligibleToMigrate === 0 && queuedToMigrate === 0;

  return {
    eligibleToMigrate,
    queuedToMigrate,
    isLoading,
    isEmpty,
    error,
    refetch,
  };
};

export default useOpenTofuMigration;
